import { MutationTree } from 'vuex';
import { BankDataState } from './types';
import { PaymentMandateData } from '@/shared/model/paymentMandateData';
import { PaymentMandateHistoryEntry } from '@/shared/model/paymentMandateHistoryEntry';

export const mutations: MutationTree<BankDataState> = {
  setBankDataIsLoading(state, payload: boolean) {
    state.isLoading = payload;
  },
  setBankDataPaymentMandate(state, payload: PaymentMandateData) {
    state.paymentMandate = payload;
  },
  setBankDataPaymentMandateHistory(
    state,
    payload: PaymentMandateHistoryEntry[]
  ) {
    state.paymentMandateHistory = payload;
  },
};
